

import { Vue, Component, Prop } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [Themeable],
})
export default class RenameWebsiteDialog extends Vue {
  @Prop() public domain!: string;

  public visible: boolean = true;

  public newDomain: string = '';

  public items: string[] = ['dns', 'email'];

  public selectedItems: string[] = [];

  private readonly DOMAIN_REGEX = /^(?=.{1,253}$)([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;

  public isChecked(item: string): boolean {
    return !this.selectedItems.includes(item);
  }

  public handleCheckboxChange(item: string): void {
    const index = this.selectedItems.indexOf(item);
    if (index > -1) {
      this.selectedItems.splice(index, 1);
    } else {
      this.selectedItems.push(item);
    }
  }

  public get domainValid(): boolean {
    const domain = (this.newDomain || '').trim();
    if (!domain) {
      return false;
    }

    return this.DOMAIN_REGEX.test(domain);
  }

  public rename(): void {
    this.$emit('renameDomain', this.newDomain.trim(), this.selectedItems);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
